import React, { useEffect, useState } from 'react';
import { flowSteps, recordFlowProgress } from '../../utils/recordFlowProgress';

import { Auth } from 'aws-amplify';
import ConfirmAddressContainer from './ConfirmAddressContainer';
import { ConsentFlows } from '../../context/ConsentContext';
import LoopSpinner from '../../ui/LoopSpinner';
import { contentfulPropTypes } from '../../propTypes';
import { getUserDetails } from '../../api/TrustPower';
import { useNavigate } from 'react-router';
import withContentfulTag from '../../utils/withContentfulTag';

const ReconfirmSoonContainer = ({ contentful, loading, fetched }) => {
  const [user, setUser] = useState(undefined);
  const [userDetails, setUserDetails] = useState(undefined);
  const navigate = useNavigate();

  useEffect(() => {
    const asyncRecordFlowProgress = async () => {
      await recordFlowProgress(
        flowSteps.RECONFIRM_SOON_LANDING,
        ConsentFlows.RECONFIRM,
      );
    };
    asyncRecordFlowProgress();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getUserDetails().then(res => {
      if (res?.consent?.reconsent_due < Date.now() / 1000) {
        navigate('/reconfirm/now');
      }
      return setUserDetails(res);
    });
    Auth.currentAuthenticatedUser().then(res => setUser(res));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return !loading && fetched ? (
    <>
      <ConfirmAddressContainer
        contentful={contentful}
        user={user}
        userDetails={userDetails}
      />
    </>
  ) : (
    <>
      <LoopSpinner />
    </>
  );
};

ReconfirmSoonContainer.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(
  ReconfirmSoonContainer,
  'web_app_reconsent_soon_alert',
);
